module.exports = __webpack_public_path__ + "images/background/image/1-4a5437715174c94c2d3d6d15ba0aa065.jpg";